export default __webpack_public_path__ + "static/media/sack.24d4e843.svg";